import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PhoneValidator } from '@iqd/shared-utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Apollo, gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';

const sendAccessRequestEmail: DocumentNode = gql`
  mutation sendEmail($sendEmailInput: SendEmailInput!) {
    sendEmail(sendEmailInput: $sendEmailInput)
  }
`;

@Component({
  selector: 'app-request-access-modal',
  templateUrl: './request-access-modal.component.html',
  styleUrls: ['./request-access-modal.component.scss'],
})
export class RequestAccessModalComponent {
  form: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private apollo: Apollo,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  private createForm(): void {
    this.form = this.fb.group({
      name: [null, Validators.required],
      companyName: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      phoneNumber: [
        null,
        [Validators.required, PhoneValidator.validCountryPhone('GB')],
      ],
    });
  }

  onSubmit(): void {
    this.apollo
      .mutate({
        mutation: sendAccessRequestEmail,
        variables: {
          sendEmailInput: {
            toAddresses: ['sales@hi-level.co.uk'],
            replyToAddresses: [this.form.value.email],
            subject: 'iQD Access Request',
            text: `Name: ${this.form.value.name}\r\n
               Company: ${this.form.value.companyName}\r\n
               Email: ${this.form.value.email}\r\n
               Phone: ${this.form.value.phoneNumber}`,
            html: `<p>Name: ${this.form.value.name}</p>
              <p>Company: ${this.form.value.companyName}</p>
               <p>Email: ${this.form.value.email}</p>
               <p>Phone: ${this.form.value.phoneNumber}</p>`,
          },
        },
      })
      .subscribe((res) => {
        this.activeModal.close();
      });
  }
}
